import type { ServicePermissions } from '@/enums/ServicePermissions'
import type { UserInfo } from '@/models/UserInfo'
import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => {
    return {
      User: {} as UserInfo
    }
  },
  persist: {
    storage: sessionStorage
  },
  getters: {
    getUser(state): UserInfo {
      return state.User
    },
    getPermissions(state): ServicePermissions[] {
      return state.User.servicePermissions
    }
  },
  actions: {
    updateUser(user: UserInfo) {
      this.User = user
    },
    updatePermissions(servicePermissions: ServicePermissions[]) {
      if (this.User) {
        this.User.servicePermissions = servicePermissions
      }
    }
  }
})
